import Step9 from "./Step9";

const GroupedStep3 = ({ text, formToShow, deliveryInfo }) => {
  return (
    <Step9
      text={text}
      formToShow={formToShow}
      deliveryInfo={deliveryInfo}
    />
  );
};

export default GroupedStep3;